// @flow
export { default } from './WriteExtraTempSaveList';



// WEBPACK FOOTER //
// ./src/components/write/WriteExtraTempSaveList/index.js